import React, { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from 'lucide-react'

import { isRunningInElectron } from 'utils/electron'
import { SearchInput } from 'ui/SearchInput/SearchInput'

export const NAVBAR_PADDING = 'pt-10'
export const showBrowserNavigationBar = isRunningInElectron

export const BrowserNavigationBar: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  const handleForward = useCallback(() => {
    navigate(1)
  }, [navigate])

  if (!showBrowserNavigationBar) return null

  return (
    <div className="flex items-center bg-[#EDEDED] p-1.5 border-b border-gray-300 shadow-sm sticky top-0 w-full z-[9999] gap-2">
      <button onClick={handleBack} className="p-1 mr-2 rounded hover:bg-[#E4E4E4] focus:outline-none focus:ring-0">
        <ChevronLeft className="w-5 h-4 text-gray-600" strokeWidth={2} />
      </button>
      <button onClick={handleForward} className="p-1 mr-4 rounded hover:bg-[#E4E4E4] focus:outline-none focus:ring-0">
        <ChevronRight className="w-5 h-4 text-gray-600" strokeWidth={2} />
      </button>
      <div className="flex-grow">
        <input
          className="text-xs text-gray-400 truncate w-full px-3 py-1 rounded border border-gray-300 bg-gray-50 focus:outline-none"
          readOnly
          value={`${window.location.protocol}//${window.location.host}${location.pathname}`}
          onClick={(e: any) => e.target.select()}
        />
      </div>
      <div>
        <SearchInput />
      </div>
    </div>
  )
}
